<template>
  <div id="chatbot"></div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: "ChatBot",

  mounted() {
    const injectScript = document.createElement("script");
    injectScript.src = "//code.tidio.co/gx3uvfp7lu2dhjq53mdkvooaoxwm2tjb.js";
    injectScript.async = true;
    document.head.appendChild(injectScript);

    injectScript.onerror = () => {
      console.error("Error loading ChatBot script");
    };
  },
});
</script>
